import { selectIsLoggedIn } from "@sunrise/jwt";
import { socketAtom } from "@sunrise/yallo-websocket";
import { atomEffect } from "jotai-effect";
import { continueWatchingSocketUpdatesAtom } from "./continue-watching-socket-updates.atom";
import type {
  ContinueWatchingUpdate,
  FullyWatchedItem,
} from "@sunrise/backend-types";
import { fullyWatchedSocketUpdatesAtom } from "./fully-watched-socket-updates.atom";

export const reactForContinueWatchingToSocketEffect = atomEffect((get, set) => {
  const ws = get(socketAtom);
  const isLoggedIn = get(selectIsLoggedIn);

  if (!ws || !isLoggedIn) {
    return;
  }

  ws.on("continue-watching", (event) => {
    set(continueWatchingSocketUpdatesAtom, event as ContinueWatchingUpdate);
  });

  ws.on("fully-watched", (event) => {
    set(fullyWatchedSocketUpdatesAtom, event as FullyWatchedItem);
  });

  return () => {
    // TODO: add a ws.off to the socket.
  };
});
